export const timezones = [
    { value: "EST", label: "EST - Eastern Standard Time" },
    { value: "EDT", label: "EDT - Eastern Daylight Time" },
    { value: "CST", label: "CST - Central Standard Time" },
    { value: "CDT", label: "CDT - Central Daylight Time" },
    { value: "MST", label: "MST - Mountain Standard Time" },
    { value: "MDT", label: "MDT - Mountain Daylight Time" },
    { value: "PST", label: "PST - Pacific Standard Time" },
    { value: "PDT", label: "PDT - Pacific Daylight Time" },
    { value: "AKST", label: "AKST - Alaska Standard Time" },
    { value: "AKDT", label: "AKDT - Alaska Daylight Time" },
    { value: "HAST", label: "HAST - Hawaii-Aleutian Standard Time" },
    { value: "HADT", label: "HADT - Hawaii-Aleutian Daylight Time" },
  ];

export const getTimeZone = async (zipCode) => {  

  const key = 'b9bfa67637ec4e58b8d929e649d0948f';
  const country = 'us';

  // ---- Timezone mapping (same method as county) ----
  const TIMEZONE_OVERRIDES = {
    "11555": "EST",
    "10001": "EST",
    "10002": "EST",
    "10451": "EST",
    "11201": "EST",

    "33101": "EST",
    "33012": "EST",

    "77001": "CST",
    "77002": "CST",
    "75001": "CST",

    "60601": "CST",
    "60602": "CST",

    "85001": "MST",
    "85002": "MST",
    "85701": "MST",

    "89101": "PST",
    "89102": "PST",

    "99501": "AKST",
    "96801": "HAST"
  };

  // ---- First check manual overrides ----
  if (TIMEZONE_OVERRIDES[zipCode]) {
    return TIMEZONE_OVERRIDES[zipCode];
  }

  // ---- API Fallback ----
  try {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${zipCode}&key=${key}&countrycode=${country}`
    );

    const data = await response.json();

    if (data.status.code === 200 && data.total_results > 0) {
      return data.results[0]?.annotations?.timezone?.short_name || null;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};
